import * as types from './types'

const initialState: types.IStateEditor = {
  navigation: {},
  statusQuestionChanged: false
}

export function editorReducers(
  state = initialState,
  action: types.IEditorActionTypes
):types.IStateEditor{
  switch(action.type){
    case types.UPDATE_NAVIGATION_EDITOR:
      return {
        ...state,
        navigation: {...state.navigation, ...action.payload}
      }
    case types.UPDATE_STATUS_QUESTION_CHANGE:
      return{
        ...state,
        statusQuestionChanged: action.payload
      }
    default:
      return{
        ...state
      }
  }
}
